export default "__VITE_ASSET__47321bd2__"